import { EImportEntity } from '../importer/model';
import { importReducer } from '../importer/reducer';

export const ancillaryActivitiesImport = importReducer(EImportEntity.ANCILLARY_ACTIVITIES);
